"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderEnum = void 0;
var OrderEnum;
(function (OrderEnum) {
    OrderEnum["ASC"] = "asc";
    OrderEnum["DESC"] = "desc";
})(OrderEnum = exports.OrderEnum || (exports.OrderEnum = {}));
